var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"text-gray-600 hover:text-blue-600 font-semibold uppercase text-xs tracking-wider leading-normal cursor-pointer",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }